import { render, staticRenderFns } from "./safeSetting.vue?vue&type=template&id=4ee78486&scoped=true"
import script from "./safeSetting.vue?vue&type=script&lang=js"
export * from "./safeSetting.vue?vue&type=script&lang=js"
import style0 from "./safeSetting.vue?vue&type=style&index=0&id=4ee78486&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ee78486",
  null
  
)

export default component.exports